import { Observable, of } from "rxjs";

import { ProductIdProviderInterface } from "./ProductIdProviderInterface";

export class ProductIdFromStaticProvider implements ProductIdProviderInterface {
    constructor(private readonly _productId: number) {}

    selectProductId(): Observable<number> {
        return of(this._productId);
    }
}
